import { sendAnalyticsEvent } from 'dpl/util/analytics';
import { ANALYTICS_EVENTS } from 'dpl/constants/analytics';

const CUSTOM_QUESTIONS_INPUT = 'custom_questions';
const QUIZ_QUESTION_TYPES = {
  CUSTOM: 'custom_breeder_question',
  STANDARD: 'standard_question'
};

export function trackQuizQuestionSubmitted(quiz, section, eventProps, answers) {
  const sectionTitle = section.title || section.component_props.title;
  const firstQuestionTitle = section.questions[0].title;
  const questionContent =
    sectionTitle || firstQuestionTitle || section.component_name;
  const questionType =
    section.questions[0].input_name === CUSTOM_QUESTIONS_INPUT
      ? QUIZ_QUESTION_TYPES.CUSTOM
      : QUIZ_QUESTION_TYPES.STANDARD;

  sendAnalyticsEvent(ANALYTICS_EVENTS.CONTACT_QUESTION_SUBMITTED, {
    quiz_name: quiz.name,
    quiz_question: questionContent,
    quiz_version: quiz.version,
    quiz_question_position: quiz.sections.indexOf(section),
    quiz_question_type: questionType,
    quiz_question_response: answers,
    ...eventProps
  });
}

export function trackQuizQuestionViewed(quiz, section, eventProps) {
  const sectionTitle = section.title || section.component_props.title;
  const firstQuestionTitle = section.questions[0].title;
  const questionContent =
    sectionTitle || firstQuestionTitle || section.component_name;
  const questionPosition = quiz.sections.indexOf(section);
  const questionType =
    section.questions[0].input_name === CUSTOM_QUESTIONS_INPUT
      ? QUIZ_QUESTION_TYPES.CUSTOM
      : QUIZ_QUESTION_TYPES.STANDARD;

  sendAnalyticsEvent(ANALYTICS_EVENTS.CONTACT_QUESTION_VIEWED, {
    quiz_name: quiz.name,
    quiz_question: questionContent,
    quiz_version: quiz.version,
    quiz_question_position: questionPosition,
    quiz_question_type: questionType,
    ...eventProps
  });

  if (questionPosition === quiz.sections.length - 1) {
    sendAnalyticsEvent(ANALYTICS_EVENTS.CONTACT_QUIZ_COMPLETED, {
      quiz_name: quiz.name,
      quiz_version: quiz.version,
      ...eventProps
    });
  }
}
